// extracted by mini-css-extract-plugin
export default {"container":"Selection_container__racY3","arrowDown":"Selection_arrowDown__FaCZR","openState":"Selection_openState__A-ros","optionsList":"Selection_optionsList__GkpeC"};